import React, { useState } from 'react'

import { ReactComponent as Rewind } from '../images/backward2.svg'
import { ReactComponent as Forward } from '../images/forward2.svg'
import { Link } from 'react-router-dom'

import { ReactComponent as Home } from '../images/home.svg'
import { ReactComponent as Replay } from '../images/replay-meditation_edited.svg'
import AudioPlayer from 'react-h5-audio-player'
import 'react-h5-audio-player/lib/styles.css'
import styled from 'styled-components'

const contentTimingShared = `
font-weight: 700;
display: inline-block;
position: relative;
color: #707070;
`
const svgParameters = `
width: 1em !important;
height: 1em !important;
margin-right: 0.5rem;
&:hover {
  fill: #539CFF; 
}
`

const WrapperDiv = styled.section`
  font-family: 'museo-sans', sans-serif;
  max-width: 276pt;
  margin: auto;
  box-shadow: 2pt 5pt 16pt #41717638;
  background-color: #ffffff;
  border-radius: 16px;
  min-height: 212pt;
  width: 100%;

  h2 {
    margin: auto;
    padding: 1pt 0 5pt;
    text-align: center;
    font-size: 20pt;
    color: #404040;
    font-family: 'museo-sans', sans-serif;
    font-weight: 500;
    width: 60%;
    margin: 0px auto !important;
  }
  div {
    border-radius: 16px;
  }
  .rhap_container {
    box-shadow: none;
  }

  .rhap_progress-section {
    display: none;
  }
  .rhap_progress-bar {
    height: 8pt !important;
    width: 242pt !important;
    border-radius: 30pt !important;
    background-color: #addaf8 !important;
  }
  .rhap_progress-indicator {
    background-color: #389adc;
    box-shadow: 1pt 1pt 10pt #539cff;
    top: -5px !important;
  }
  .rhap_progress-filled {
    background-color: #3498db !important;
  }
  .rhap_download-progress {
    background-color: #3498db !important;
  }

  #rhap_current-time {
    top: 38pt;
    left: 3%;
    ${contentTimingShared}
  }
  .rhap_total-time {
    left: 79%;
    top: 9pt;
    ${contentTimingShared}

    @media screen and (min-width: 475px) {
      left: 280px;
    }
  }

  .rhap_additional-controls,
  .rhap_volume-controls {
    display: none;
  }
  .rhap_main-controls {
    margin: 0pt auto;
    width: 100%;
  }
  .rhap_play-pause-button {
    svg {
      width: 2em !important;
      height: 2em !important;
    }
    &[aria-label='Play'] {
      svg {
        path {
          fill: #006b9f;
        }
      }
    }
    &[aria-label='Pause'] {
      svg {
        path {
          fill: #4eb8ff;
        }
      }
    }
  }
  .rhap_button-clear {
    width: 83px;
    height: 83px;
    overflow: visible;
  }
  .rhap_rewind-button {
    visibility: hidden;
  }
  .rhap_forward-button {
    visibility: hidden;
  }
`
const H2wrapper = styled.div`
  margin-top: 27pt;
`

const ReplayWrapperDiv = styled.div`
width: 80%;
margin: 20px auto;
display: grid;
grid-column-templates: 1fr;
justify-content: space-around;
margin-bottom: 27pt;

div {
  cursor: pointer;
  display: flex;
}

svg {
  ${svgParameters}
}
 
a {
  display: flex;
  margin-top: 1rem;
  justify-content: center; 
} 
  svg {
    ${svgParameters}
  }
}
`
const Text = styled.p`
  margin: 0;
  color: #404040 !important;
  text-decoration: none !important;
  font-size: 1.25rem !important;
  &:hover {
    color: #539cff !important;
  }
`

const Player = ({ text, audioSrc }) => {
  const [isHidden, setIsHidden] = useState(true)
  const [playStatus, setPlayStatus] = useState(false)
  const line1 = text.split('\n')[0]
  const line2 = text.split('\n')[1]

  const playButton = () => {
    setPlayStatus(true)
    document.getElementsByClassName('rhap_rewind-button')[0].style.visibility = 'visible'
    document.getElementsByClassName('rhap_forward-button')[0].style.visibility = 'visible'
    document.getElementsByClassName('rhap_progress-section')[0].style.display = 'block'
  }

  const ending = () => {
    document.getElementsByClassName('rhap_rewind-button')[0].style.display = 'none'
    document.getElementsByClassName('rhap_forward-button')[0].style.display = 'none'
    document.getElementsByClassName('rhap_play-pause-button')[0].style.display = 'none'
    setIsHidden(!isHidden)
  }

  const playAgain = () => {
    setIsHidden(!isHidden)
    document.getElementsByClassName('rhap_rewind-button')[0].style.display = 'block'
    document.getElementsByClassName('rhap_forward-button')[0].style.display = 'block'
    document.getElementsByClassName('rhap_play-pause-button')[0].style.display = 'block'
  }

  return (
    <WrapperDiv>
      <H2wrapper>
        {playStatus ? (
          <>
            <h2>{line1}</h2>
            <h2>{line2}</h2>
          </>
        ) : (
          <h2>To begin the meditation, press play</h2>
        )}
      </H2wrapper>
      <AudioPlayer
        src={audioSrc}
        onPlay={() => playButton()}
        onEnded={() => ending()}
        progressJumpStep={30000}
        customIcons={{
          rewind: <Rewind />,
          forward: <Forward />,
        }}
      />
      {!isHidden && (
        <ReplayWrapperDiv>
          <div onClick={() => playAgain()}>
            <Replay />
            <Text>Replay meditation</Text>
          </div>
          <Link to="/">
            <Home />
            <Text>Back to home</Text>
          </Link>
        </ReplayWrapperDiv>
      )}
    </WrapperDiv>
  )
}

export default Player
